import { useEffect, useState } from 'react';
import { Modal } from '@/components/modals/modal';
import { Button } from '@/components/ui/button';
import { id } from '@/i18n/id';

type IdleOverlayProps = {
  open: boolean;
  /** Seconds shown counting down before auto-reset. */
  countdownFrom?: number;
  onContinue: () => void;
};

/**
 * "Masih di sini?" warning shown at 50s idle. The 10s countdown is display-only —
 * the actual reset is owned by the idle timer (fires at 60s).
 */
export function IdleOverlay({ open, countdownFrom = 10, onContinue }: IdleOverlayProps) {
  const [seconds, setSeconds] = useState(countdownFrom);

  useEffect(() => {
    if (!open) {
      setSeconds(countdownFrom);
      return;
    }
    const interval = setInterval(() => setSeconds((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(interval);
  }, [open, countdownFrom]);

  return (
    <Modal open={open} dismissOnScrim={false} role="alertdialog" labelledBy="idle-title">
      <div className="flex flex-col items-center gap-5 text-center">
        <span aria-hidden className="text-6xl">
          ⏱️
        </span>
        <h2 id="idle-title" className="text-3xl font-bold text-ink">
          {id.idle.title}
        </h2>
        <p className="text-lg text-ink-muted">{id.idle.subtitle}</p>
        <Button autoFocus fullWidth onClick={onContinue}>
          {id.idle.continue(seconds)}
        </Button>
      </div>
    </Modal>
  );
}
